import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { updateBillNotes } from '../../services/BillService';
import { sanitizeMultilineText } from '../../utils/sanitize';

const UpdateNotesModal = ({
  show,
  handleClose,
  bill,
  onUpdateNotes
}) => {
  const [notes, setNotes] = useState('');
  const [error, setError] = useState(null);
  const [hasDecryptionError, setHasDecryptionError] = useState(false);

  useEffect(() => {
    // Check if the notes have a decryption error
    const notesValue = bill?.notes || '';
    const isDecryptionError = typeof notesValue === 'string' && 
                             (notesValue.startsWith('DECRYPTION_ERROR') || 
                              notesValue.startsWith('ENCRYPTION_ERROR'));
    
    if (isDecryptionError) {
      setHasDecryptionError(true);
      // Set empty notes when there's a decryption error
      setNotes('');
    } else {
      setHasDecryptionError(false);
      setNotes(notesValue);
    }
  }, [bill]);

  const handleSave = async () => {
    try {
      setError(null);
      const updatedBill = await updateBillNotes(bill.id, sanitizeMultilineText(notes));
      onUpdateNotes(updatedBill);
      handleClose();
    } catch (error) {
      console.error('Error saving notes:', error.name);
      setError('Failed to save notes. Please try again.');
    }
  };

  const handleNotesChange = (e) => {
    setNotes(sanitizeMultilineText(e.target.value));
  };

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="mobile-responsive-modal">
      <Modal.Header closeButton>
        <Modal.Title>Edit Notes for {bill?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        
        {hasDecryptionError && (
          <Alert variant="warning">
            The previous notes could not be decrypted. This may happen after updating your encryption key.
            Any notes you enter now will replace the old encrypted notes.
          </Alert>
        )}
        
        <Form>
          <Form.Group>
            <Form.Control
              as="textarea"
              rows={3}
              value={notes}
              onChange={handleNotesChange}
              placeholder="Enter notes for this bill"
            />
            <Form.Text className="text-muted">
              You can use spaces and line breaks (Enter) anywhere in this text, including at the beginning and end.
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateNotesModal;
